import { HighscoresAPI, useDailyHighscores, useHighscores } from './highscores';
import { QuizzesAPI } from './quizzes';
import { PlaylistsAPI } from './playlists';
import { OffersAPI } from './offers';
import { CouponsAPI } from './coupons/CouponsAPI';
import { BingoAPI } from './bingo';

export const Database = {
    highscore: HighscoresAPI,
    quizzes: QuizzesAPI,
    playlists: PlaylistsAPI,
    offers: OffersAPI,
    coupons: CouponsAPI,
    bingo: BingoAPI,
    useHighscores,
    useDailyHighscores,
};
